import anime from 'animejs';
import {delay} from './async';

export function simpleObjectCopy<T extends object>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}

export function mountIfElExist(...list: { vueExt: any; elId: string }[]): void {
  list.forEach(vm => {
    if (document.getElementById(vm.elId)) {
      new vm.vueExt().$mount(`#${vm.elId}`);
    }
  });
}

export function debounce(func: () => void, wait: number, immediate = false) {
  let timeout: any;

  return function () {
    // @ts-ignore
    const self = this;
    // @ts-ignore
    const args = arguments;

    const later = function () {
      timeout = null;
      // @ts-ignore
      if (!immediate) func.apply(self, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    // @ts-ignore
    if (callNow) func.apply(self, args);
  };
}

export function getCoords(elem: HTMLElement) {
  const box = elem.getBoundingClientRect();

  return {
    top: box.top + pageYOffset,
    left: box.left + pageXOffset,
    bottom: box.top + pageYOffset + elem.clientHeight
  };
}

export function isInViewport(element: HTMLElement) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function inArray(val: any, items: Array<any>): boolean {
  return items.findIndex(el => el == val) != -1;
}


export function makeFormData(data: any): FormData {
  const form = new FormData();

  for (const k in data) {
    if (typeof data[k] == 'string' || typeof data[k] == 'boolean') {
      form.append(k, data[k]);
    }
  }

  return form;
}

export async function animateText(textWrapper: HTMLElement, delayMs = 100) {
  if (textWrapper != null) {

    const str = textWrapper.textContent!.split(' ').map((el) => {
      return el.replace(/\S/g, '<span class=\'letter\'>$&</span>')
    });

    console.log('<span style="white-space: nowrap">' + str.join('</span> <span>') + '</span>');
    textWrapper.innerHTML = '<span style="white-space: nowrap">' + str.join('</span> <span style="white-space: nowrap">') + '</span>';

    // textWrapper.innerHTML = textWrapper.textContent!.replace(/\S/g, '<span class=\'letter\'>$&</span>');

    await delay(delayMs);

    anime.timeline({ loop: false })
      .add({
        targets: '.letter',
        rotateY: [-90, 0],
        duration: 1300,
        delay: (el, i) => 45 * i
      }).add({
      targets: textWrapper,
      opacity: 1,
      duration: 1000,
      easing: 'easeOutExpo',
      delay: 1000
    });
  }
}

export function loadScript(src: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.onload = resolve
    script.onerror = reject
    script.src = src
    document.head.append(script)
  })
}

export function getUniqueID() {
  return Math.random().toString(36).slice(2);
}

export function getBranch() {
  // @ts-ignore
  return gBranches.find((el) => el.id == gBranchId);
}

export function getBranches(): any[] {
  // @ts-ignore
  return gBranches || [];
}

export function smoothScrollTo(selector: string, hard = false) {
  const el = document.querySelector<HTMLElement>(selector);
  if (!el) return;

  const styles = window.getComputedStyle(el);
  const coords = getCoords(el);
  const top = coords.top - parseInt(styles.marginTop) - 50;
  
  if (hard) {
    document.documentElement.scrollTop = top;
    document.body.scrollTop = top;
    return;
  }

  window.scroll({
    top: top,
    left: 0,
    behavior: 'smooth',
  });
}